export default [
  { value: "فروشگاه", label: "فروشگاه" },
  { value: "مغازه", label: "مغازه" },
  { value: "شرکت", label: "شرکت" },
  { value: "بازرگانی", label: "بازرگانی" },
  { value: "موسسه", label: "موسسه" },
  { value: "آموزشگاه", label: "آموزشگاه" },
  { value: "اتحادیه", label: "اتحادیه" },
  { value: "باشگاه", label: "باشگاه" },
  { value: "شخصی", label: "شخصی" },
  { value: "پیمانکاری", label: "پیمانکاری" },
];
